const colors = {
    blue:        '#3AE',
    brightBlue:  '#4BF',
    green:       '#6EC',
    darkGreen:   '#3B9',
};

export default colors